export default __webpack_public_path__ + "static/media/eth-grey-icon.b7f08ee8.svg";